import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
// Import debug utility (only loads, doesn't execute unless called)
import "./utils/debugApi";
import "./i18n";

import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Login from "./pages/SignIn/SignIn";
import { Dashboard } from "./pages/Dashboard/Dashboard";
import Home from "./pages/Dashboard/Home/Home";
import ManageCarWashes from "./pages/Dashboard/ManageCarWashes";
import { AlertProvider } from "./context/AlertContext";
import App from "./App";
import ManageOwners from "./pages/Dashboard/ManageOwners/ManageOwners";
import ManageUsers from "./pages/Dashboard/ManageUsers/ManageUsers";
import UserDetail from "./pages/Dashboard/ManageUsers/UserDetail";
import ProtectedRoute from "./components/ProtectedRoute";
import SuperAdminRoute from "./components/SuperAdminRoute";
import VehicleCatalog from "./pages/Dashboard/VehicleCatalog/VehicleCatalog";
import VehicleTypeReviews from "./pages/Dashboard/VehicleTypeReviews/VehicleTypeReviews";
import CarWash from "./pages/Dashboard/CarWash";
import CarWashInfo from "./pages/Dashboard/CarWash/screens/CarWashInfo";
import ContactDetails from "./pages/Dashboard/CarWash/screens/ContactDetails";
import Prices from "./pages/Dashboard/CarWash/screens/Prices";
import Reviews from "./pages/Dashboard/CarWash/screens/Reviews";
import CarWashWashingHistory from "./pages/Dashboard/CarWash/screens/WashingHistory";
import Owner from "./pages/Dashboard/Owner/Owner";
import OwnerInfo from "./pages/Dashboard/Owner/screens/OwnerInfo";
import Statistics from "./pages/Dashboard/Owner/screens/Statistics";
import WashingHistory from "./pages/Dashboard/Owner/screens/WashingHistory";
import WashingCenters from "./pages/Dashboard/Owner/screens/WashingCenters";
import Employees from "./pages/Dashboard/Owner/screens/Employees";
import EmployeeWashingHistory from "./pages/Dashboard/Owner/screens/EmployeeWashingHistory";
import Contract from "./pages/Dashboard/Owner/screens/Contract";
import RelationshipManager from "./pages/Dashboard/Owner/screens/RelationshipManager";
import SupportCases from "./pages/Dashboard/Owner/screens/SupportCases";
import PaymentHistory from "./pages/Dashboard/Owner/screens/PaymentHistory";
import Logs from "./pages/Dashboard/Owner/screens/Logs";
import WashManagement from "./pages/Dashboard/WashManagement/WashManagement";
import WashDetail from "./pages/Dashboard/WashManagement/WashDetail";
import AdminManagement from "./pages/Dashboard/AdminManagement/AdminManagement";
import RMDetail from "./pages/Dashboard/AdminManagement/RMDetail";
import Profile from "./pages/Dashboard/Profile/Profile";
import WashingClassSettings from "./pages/Dashboard/Settings/WashingClass";
import ReasonsSettings from "./pages/Dashboard/Settings/Reasons";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/dashboard",
    element: <ProtectedRoute />, // Protect dashboard and its children
    children: [
      {
        path: "",
        element: <Dashboard />,
        children: [
          { index: true, element: <Home /> },
          { path: "manage-car-washes", element: <ManageCarWashes /> },
          {
            path: "manage-car-washes/:carWashID",
            element: <CarWash />,
            children: [
              { path: "info", element: <CarWashInfo /> },
              { path: "contact-details", element: <ContactDetails /> },
              { path: "statistics", element: <></> },
              { path: "washing-history", element: <CarWashWashingHistory /> },
              { path: "prices", element: <Prices /> },
              { path: "pending-reviews", element: <Reviews /> },
              { path: "support-cases", element: <></> },
              { path: "logs", element: <></> },
            ],
          },
          {
            path: "manage-owners",
            element: <ManageOwners />,
          },
          {
            path: "manage-owners/:ownerID",
            element: <Owner />,
            children: [
              { path: "info", element: <OwnerInfo /> },
              { path: "statistics", element: <Statistics /> },
              { path: "washing-history", element: <WashingHistory /> },
              { path: "washing-centers", element: <WashingCenters /> },
              { path: "employees", element: <Employees /> },
              {
                path: "employees/:employeeId/washing-history",
                element: <EmployeeWashingHistory />,
              },
              { path: "contract", element: <Contract /> },
              {
                path: "relationship-manager",
                element: <RelationshipManager />,
              },
              { path: "support-cases", element: <SupportCases /> },
              { path: "payment-history", element: <PaymentHistory /> },
              { path: "logs", element: <Logs /> },
            ],
          },
          {
            path: "washes",
            element: <WashManagement />,
          },
          {
            path: "washes/:washId",
            element: <WashDetail />,
          },
          {
            path: "admins",
            element: <SuperAdminRoute />,
            children: [
              { index: true, element: <AdminManagement /> },
              { path: ":adminId", element: <RMDetail /> },
            ],
          },
          {
            path: "manage-users",
            element: <SuperAdminRoute />,
            children: [
              { index: true, element: <ManageUsers /> },
              { path: ":userId/info", element: <UserDetail /> },
            ],
          },
          {
            path: "vehicle-catalog",
            element: <VehicleCatalog />,
          },
          {
            path: "vehicle-type-reviews",
            element: <VehicleTypeReviews />,
          },
          {
            path: "settings/washing-class",
            element: <WashingClassSettings />,
          },
          {
            path: "settings/reasons",
            element: <SuperAdminRoute />,
            children: [{ index: true, element: <ReasonsSettings /> }],
          },
          {
            path: "profile",
            element: <Profile />,
          },
        ],
      },
    ],
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <AlertProvider>
      <RouterProvider router={router} />
    </AlertProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
